<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
<div class="rounded-xl">
    <!-- Header Section -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 sm:mb-6 gap-3 sm:gap-0">
        <h2 class="text-lg sm:text-2xl font-bold text-gray-900">Transaction Management</h2>
    </div>

    <!-- Filters Section -->
    <div class="filters-section mb-4">
        <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <div class="flex-grow md:mr-4">
                <div class="relative">
                    <input type="text" pInputText placeholder="Search..." [(ngModel)]="searchTerm" (input)="onSearchInput($event)" class="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-500 pr-10">
                    <button *ngIf="searchTerm" (click)="clearSearch()" class="absolute top-1/2 right-2 -translate-y-1/2 text-gray-500 hover:text-gray-700">
                        <i-lucide name="x" class="h-5 w-5"></i-lucide>
                    </button>
                </div>
            </div>
            <div class="status-filter">
                <p-dropdown [options]="statusOptions" [(ngModel)]="statusFilter" (onChange)="onFilterChange()" styleClass="w-full md:w-auto"></p-dropdown>
            </div>
        </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>Loading transactions...</p>
    </div>

    <!-- Transactions Table -->
    <div *ngIf="!isLoading" class="transactions-table-container">
        <div class="overflow-x-auto">
            <p-table [value]="filteredTransactions" [paginator]="false"
                     [responsiveLayout]="responsiveLayout"
                     [tableStyle]="{ 'min-width': tableMinWidth }"
                     class="p-datatable-sm w-full">
                <ng-template pTemplate="header">
                    <tr class="bg-gray-50">
                        <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 150px;">Investor</th>
                        <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 120px;">Portfolio</th>
                        <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 100px;">Amount</th>
                        <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 80px;">Tickets</th>
                        <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 80px;">Status</th>
                         <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 100px;">Processed Date</th>
                         <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 100px;">Reference Number</th>
                         <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 100px; max-width: 120px;">Notes</th>
                        <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase truncate" style="min-width: 120px;">Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-transaction>
                    <tr class="hover:bg-gray-50 transition-colors">
                        <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap">
                            <div class="user-name text-xs sm:text-sm font-medium text-gray-900">{{ transaction.userId.fullName }}</div>
                            <div class="user-email text-xs text-gray-500">{{ transaction.userId.email }}</div>
                        </td>
                        <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap">
                            <div class="portfolio-name text-xs sm:text-sm font-medium text-gray-900">{{ transaction?.portfolioId?.name }}</div>
                            <div class="ticket-price text-xs text-gray-500">{{ formatCurrency(transaction?.portfolioId?.ticketPrice) }}/ticket</div>
                        </td>
                        <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-green-700 font-semibold text-xs sm:text-sm">
                            
                            {{ formatCurrency(transaction.amount) }}
                        </td>
                        <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-xs sm:text-sm">
                            {{ transaction.ticketsPurchased }}
                        </td>
                         <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap">
                            <span [ngClass]="getStatusClass(transaction.status)"
                                class="px-1 sm:px-2 py-0.5 sm:py-1 rounded-full text-xs font-semibold">
                                {{ transaction.status }}
                            </span>
                        </td>
                        <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-gray-600 text-xs">
                            {{transaction?.processedAt | date:'medium'  }}
                        </td>
                        <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-gray-600 text-xs">
                            {{transaction?.referenceNumber || '-'}}
                        </td>
                        <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-gray-600 text-xs">
                            {{transaction?.notes || '-'}}
                        </td>
                        <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap">
                            <div class="flex gap-1 sm:gap-2 items-center" *ngIf="transaction.status === 'Pending'">
                                <button (click)="showConfirmation(transaction, 'approve')" [disabled]="isUpdating"
                                    class="p-1 sm:p-2 rounded-full bg-green-100 hover:bg-green-200 text-green-700 hover:text-green-900 transition disabled:opacity-50 disabled:cursor-not-allowed"
                                     pTooltip="Approve"  >
                                    <ng-container *ngIf="isUpdating; else approveIcon">
                                        <i-lucide name="loader-circle" class="h-3 w-3 sm:h-4 sm:w-4 animate-spin"></i-lucide>
                                    </ng-container>
                                    <ng-template #approveIcon>
                                        <i-lucide name="check" class="h-3 w-3 sm:h-4 sm:w-4"></i-lucide>
                                    </ng-template>
                                </button>
                                <button (click)="showConfirmation(transaction, 'reject')" [disabled]="isUpdating"
                                    class="p-1 sm:p-2 rounded-full bg-red-100 hover:bg-red-200 text-red-700 hover:text-red-900 transition disabled:opacity-50 disabled:cursor-not-allowed"
                                    pTooltip="Reject"  >
                                    <ng-container *ngIf="isUpdating; else rejectIcon">
                                        <i-lucide name="loader-circle" class="h-3 w-3 sm:h-4 sm:w-4 animate-spin"></i-lucide>
                                    </ng-container>
                                    <ng-template #rejectIcon>
                                        <i-lucide name="x" class="h-3 w-3 sm:h-4 sm:w-4"></i-lucide>
                                    </ng-template>
                                </button>
                                <button (click)="confirmDelete(transaction)" [disabled]="isUpdating"
                                    class="p-1 sm:p-2 rounded-full bg-white border border-red-300 hover:bg-red-50 text-red-600 hover:text-red-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
                                    pTooltip="Delete (cannot be undone)">
                                    <ng-container *ngIf="isUpdating; else deleteIcon">
                                        <i-lucide name="loader-circle" class="h-3 w-3 sm:h-4 sm:w-4 animate-spin"></i-lucide>
                                    </ng-container>
                                    <ng-template #deleteIcon>
                                        <i-lucide name="trash-2" class="h-3 w-3 sm:h-4 sm:w-4"></i-lucide>
                                    </ng-template>
                                </button>
                            </div>
                            <div *ngIf="transaction.status !== 'Pending'" class="flex items-center gap-2">
                                <span class="text-xs sm:text-sm text-gray-500 italic">Processed</span>
                                <button (click)="confirmDelete(transaction)" [disabled]="isUpdating"
                                    class="p-1 sm:p-2 rounded-full bg-white border border-red-300 hover:bg-red-50 text-red-600 hover:text-red-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
                                    pTooltip="Delete (cannot be undone)">
                                    <ng-container *ngIf="isUpdating; else deleteIcon2">
                                        <i-lucide name="loader-circle" class="h-3 w-3 sm:h-4 sm:w-4 animate-spin"></i-lucide>
                                    </ng-container>
                                    <ng-template #deleteIcon2>
                                        <i-lucide name="trash-2" class="h-3 w-3 sm:h-4 sm:w-4"></i-lucide>
                                    </ng-template>
                                </button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8" style="text-align: center;" class="text-center py-8 text-gray-400">No transactions found.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        
        <div class="mt-4 border-t border-gray-200 pt-4">
            <p-paginator [rows]="itemsPerPage" [totalRecords]="totalItems"
                [first]="(currentPage - 1) * itemsPerPage" [rowsPerPageOptions]="[10, 20, 30, 50]"
                (onPageChange)="onPageChange($event)"></p-paginator>
        </div>
    </div>

    <!-- Enhanced Confirmation Modal -->
    <p-dialog [header]="(pendingAction === 'approve' ? 'Approve' : 'Reject') + ' Transaction'" [(visible)]="showConfirmModal" [modal]="true" [closable]="true"
        [dismissableMask]="true" [style]="{width: '95vw', 'max-width': '500px'}" (onHide)="closeConfirmModal()">
        <div class="space-y-3 sm:space-y-4">
            <p class="text-sm sm:text-base text-gray-700">
                Are you sure you want to <strong>{{ pendingAction }}</strong> this transaction?
            </p>

            <div *ngIf="selectedTransaction" class="bg-gray-50 p-3 sm:p-4 rounded-lg space-y-2">
                <div class="flex justify-between items-center">
                    <span class="text-xs sm:text-sm text-gray-600">User:</span>
                    <span class="text-xs sm:text-sm font-medium text-gray-900">{{ selectedTransaction.userId.fullName }}</span>
                </div>
                <div class="flex justify-between items-center">
                    <span class="text-xs sm:text-sm text-gray-600">Portfolio:</span>
                    <span class="text-xs sm:text-sm font-medium text-gray-900">{{ selectedTransaction.portfolioId.name }}</span>
                </div>
                <div class="flex justify-between items-center">
                    <span class="text-xs sm:text-sm text-gray-600">Amount:</span>
                    <span class="text-xs sm:text-sm font-semibold text-green-700">{{ formatCurrency(selectedTransaction.amount) }}</span>
                </div>
            </div>

            <!-- Form Fields for Additional Information -->
            <div class="space-y-3 sm:space-y-4">
                <div>
                    <label for="referenceNumber" class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                        Reference Number
                        <span class="text-gray-500">(Optional)</span>
                    </label>
                    <input id="referenceNumber" type="text" [(ngModel)]="referenceNumber" 
                        placeholder="Enter reference number if applicable" 
                        class="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400 text-gray-900" 
                        maxlength="50">
                    <small class="text-xs text-gray-500 mt-1">Internal reference number for tracking purposes</small>
                </div>

                <div>
                    <label for="notes" class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                        Notes
                        <span class="text-gray-500">(Optional)</span>
                    </label>
                    <textarea id="notes" [(ngModel)]="notes" 
                        placeholder="Add any additional notes or comments..." 
                        class="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400 text-gray-900" 
                        rows="3" maxlength="500"></textarea>
                    <small class="text-xs text-gray-500 mt-1">{{ notes.length || 0 }}/500 characters</small>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row justify-end mt-4 sm:mt-6 gap-2 sm:gap-0">
                <button type="button" (click)="closeConfirmModal()"
                    class="w-full sm:w-auto cursor-pointer bg-gray-200 text-gray-700 px-4 sm:px-6 py-2 rounded-lg font-semibold sm:mr-2 hover:bg-gray-300 text-sm">Cancel</button>
                <button type="button" (click)="confirmAction()" [disabled]="isUpdating"
                    [ngClass]="pendingAction === 'approve' ? 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700' : 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700'"
                    class="w-full sm:w-auto cursor-pointer text-white px-4 sm:px-6 py-2 rounded-lg font-semibold transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed text-sm">
                    <span *ngIf="!isUpdating">
                        {{ pendingAction === 'approve' ? 'Approve Transaction' : 'Reject Transaction' }}
                    </span>
                    <span *ngIf="isUpdating" class="flex items-center justify-center">
                        <i-lucide name="loader-circle" class="animate-spin h-4 w-4 mr-2"></i-lucide>
                        Processing...
                    </span>
                </button>
            </div>
        </div>
    </p-dialog>
</div>
